import {
  CONTRIBUTOR_UPLOAD_REQUEST,
  CONTRIBUTOR_UPLOAD_COMPLETE,
  CONTRIBUTOR_UPLOAD_PROGRESS,
  CONTRIBUTOR_UPLOAD_RESET,
} from './contributorUploadsActions';

const initialState = {
  total: 0,
  current: 0,
  error: '',
  complete: false,
  uploading: false,
  failedPhotos: [],
};

const contributorUploadsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CONTRIBUTOR_UPLOAD_REQUEST:
      return {
        ...initialState,
        total: action.photos.length,
        uploading: true,
      };

    case CONTRIBUTOR_UPLOAD_PROGRESS:
      return {
        ...state,
        failedPhotos: action.uploadedPhoto.error
          ? [...state.failedPhotos, action.uploadedPhoto.file]
          : state.failedPhotos,
        current: state.current + 1,
      };

    case CONTRIBUTOR_UPLOAD_COMPLETE:
      return {
        ...state,
        uploading: false,
        complete: true,
        error: '',
      };

    case CONTRIBUTOR_UPLOAD_RESET:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default contributorUploadsReducer;
